import { Dialog, IconButton, Stack, styled, Typography } from '@mui/material';
import { ButtonCustom, ButtonOutLine } from './ButtonCustom';
import { ReactNode } from 'react';
type DialogConfirmType = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: () => void;
  textTitle?: string;
  textContent?: string;
  textButton?: string;
  textCancel?: string;
  isDelete?: boolean;
  isIconClose?: boolean;
  children?: ReactNode;
  maxWidth?: number;
  headerActions?: ReactNode;
  disabled?: boolean;
};
export const DialogConfirm = ({
  isOpen,
  onClose,
  onSubmit,
  textContent,
  textTitle,
  textButton,
  isDelete,
  isIconClose,
  children,
  maxWidth,
  textCancel,
  headerActions,
  disabled
}: DialogConfirmType) => {
  return (
    <Dialog
      PaperProps={{
        sx: { maxWidth: maxWidth || 600 }
      }}
      open={isOpen}
      onClose={onClose}
      sx={{ borderRadius: '20px' }}
      fullWidth>
      <WrapperDialog width={'100%'}>
        {isIconClose && (
          <Stack
            width={'100%'}
            flexDirection={'row'}
            px={1}
            pt={1}
            alignItems="center"
            justifyContent={'space-between'}>
            <Stack direction="row" gap={1}>
              {headerActions}
            </Stack>
            <IconButton onClick={onClose} sx={{ width: '40px', height: '40px' }}>
              <img src={'/icons/icon_cancel.svg'} alt="" />
            </IconButton>
          </Stack>
        )}
        <Stack my={3} width={'100%'} px={4.375} alignItems={'center'} gap={2.5}>
          {textTitle && <TitleStyled>{textTitle}</TitleStyled>}
          {textContent && (
            <ContentStyled textAlign={'center'} px={2.875}>
              {textContent}
            </ContentStyled>
          )}
          {children && children}
          <Stack flexDirection={'row'} gap={2} mt={3}>
            {textButton && (
              <ButtonCustom
                sx={{ width: 200 }}
                isDelete={isDelete}
                label={textButton}
                onClick={onSubmit}
                fullWidth
                disabled={disabled}
              />
            )}
            {textCancel && (
              <ButtonOutLine
                sx={{ width: 200 }}
                label={textCancel}
                onClick={onClose}
                fullWidth
                disabled={disabled}
              />
            )}
          </Stack>
        </Stack>
      </WrapperDialog>
    </Dialog>
  );
};

const WrapperDialog = styled(Stack)(() => ({
  borderRadius: '20px'
}));
const TitleStyled = styled(Typography)(() => ({
  fontSize: '26px',
  fontWeight: 700,
  color: '#2B3492',
  textAlign: 'center'
}));
const ContentStyled = styled(Typography)(() => ({
  fontSize: '20px',
  color: '#000',
  fontWeight: 400,
  whiteSpace: 'pre-line'
}));
